/**
 * DDJJ del médico versionada (análogo a VERSION_CONSENTIMIENTO). Ante un cambio
 * de texto se publica una nueva versión; la versión aceptada queda registrada en
 * la foja del médico y el operador debe re-habilitar para aceptar la nueva.
 */

export const VERSION_DDJJ_MEDICO = 'ddjj-medico-v1';

export const TEXTO_DDJJ_MEDICO = {
  version: VERSION_DDJJ_MEDICO,
  titulo: 'Declaración Jurada del Profesional Médico',
  clausulas: [
    'Poseo matrícula profesional vigente, sin suspensiones ni inhabilitaciones al momento de esta declaración.',
    'La documentación de identidad y credencial profesional presentada al operador son auténticas y de mi pertenencia.',
    'Los servicios de control médico en el marco del art. 210 de la Ley de Contrato de Trabajo serán realizados exclusivamente por mi persona, sin delegación a terceros no autorizados.',
    'Me comprometo a informar de inmediato al operador cualquier situación que afecte la vigencia de mi matrícula: suspensión, inhabilitación, baja voluntaria o sanción disciplinaria ante el colegio o entidad otorgante.',
    'Autorizo al operador a tratar mis datos profesionales a los fines de la prestación del servicio (Ley 25.326).',
  ],
  pieDeClausula:
    'La firma del formulario físico y la entrega del DNI original al operador constituyen la acreditación de identidad y habilitación profesional en esta plataforma.',
};
